import { useEffect, useState } from "react";
import { getStorage, setStorage, STORAGE } from "../utils/storage";

export const THEME = {
    LIGHT: 'light',
    DARK: 'dark'
}

export default function ThemeToggle({className}) {
    const [theme, setTheme] = useState(getStorage(STORAGE.UI_THEME))

    useEffect(() => {
        document.documentElement.setAttribute("data-theme", theme)
        setStorage(STORAGE.UI_THEME, theme)
    }, [theme])

    const themeToggled = () => {
        setTheme(prev => {
            switch(prev) {
                case THEME.LIGHT: return THEME.DARK
                default: return THEME.LIGHT
            }
        })
    }

    return(<></>
        // <button className={`icon ${className ?? 'elevated'}`} onClick={themeToggled}>
        //     <span className="material-symbols-outlined">
        //         {theme == THEME.LIGHT ? 'light_mode' : 'dark_mode'}
        //     </span>
        // </button>
    )
}